import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import library from "../../../assets/images/ideathon.jpeg";

const ColorButton = styled(Button)(() => ({
  color: "#071783",
  width: 185,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#F2C844",
  borderColor: "#F2C844",
  "&:hover": {
    color: "#071783",
    backgroundColor: "#fff",
    borderColor: "#fff",
  },
}));

const Events = () => {
  return (
    <Box>
      <Grid
        container
        display={"flex"}
        alignItems={"center"}
        margin={{ xs: "0%", sm: "5% 0%" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          margin={{ xs: "25% 0% 10% 0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "45vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          padding={{ xs: "15% 0% 25% 0%", sm: "0% 0% 3% 6%" }}
          marginBottom={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            paddingBottom={"4%"}
          >
            Upcoming Event
          </Typography>
          <Box
            component="img"
            height={{ xs: "45vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            display={{ xs: "block", sm: "none" }}
            marginTop={{ xs: "10%", sm: "0%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />
          <Typography
            variant={"h6"}
            fontWeight={400}
            textAlign={"left"}
            paddingTop={{ xs: "10%", sm: "0%" }}
            color={"#fff"}
            paddingBottom={"1%"}
          >
            OORC Ideathon 2026: Innovating Solutions for Ogbomosho’s Future
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            paddingBottom={"1%"}
          >
            May 29-30, 2026
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "5% 0% 2% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            The OORC Ideathon 2026 is a hackathon-style innovation challenge
            designed to inspire young minds and problem-solvers to develop
            practical solutions for the unique challenges facing Ogbomosho.
            Organized by the Oluseun Onigbinde Resource Centre (OORC), the
            initiative focuses on leveraging artificial intelligence, data, and
            next-generation technologies to create impactful ideas across
            critical sectors such as agriculture, healthcare, education, waste
            management, and public safety. By encouraging collaboration among
            individuals with diverse skills and backgrounds, the program aims to
            nurture innovative thinking that is both community-driven and
            scalable.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "1% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            Beyond being a competition, the OORC Ideathon serves as a platform
            for empowering innovators to turn local problems into opportunities
            for sustainable development. Participants will have the chance to
            pitch transformative ideas that address real societal needs while
            competing for prizes and recognition. With applications open from
            May 11–23, 2026, and pitching scheduled for May 29–30, 2026 at the
            OORC Innovation Hub in Ogbomosho, the event promises to foster
            creativity, entrepreneurship, and technology-driven solutions
            capable of creating lasting impact within and beyond the community.
          </Typography>
          {/* <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            padding={{ xs: "2% 0%", sm: "2% 0% 0% 0%" }}
            lineHeight={1.5}
          >
       
          </Typography> */}
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              target="_blank"
              size="medium"
              href={"https://forms.gle/o5tEYJ1uS9qx5haq7"}
            >
              Register Now
            </ColorButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Events;
